import styled from 'styled-components';
import { COLORS } from '../../constants/radar';

export const Container = styled.div`
  padding: 24px 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.BACKGROUND_PRIMARY};
  margin: 0;
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  overflow: hidden;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.$isPanelsVisible ? '12px' : '0'};
  flex: 1;
  padding: 0 24px;
  overflow: hidden;
`;

export const ChartPanel = styled.div`

  flex: 1;
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  overflow: auto;
  
  > div {
    flex: 1;
    width: 100%;
    height: auto;
    min-height: 500px;
  }
`; 